/**
 * Check if phone numbers are valid
 * @param {Object} contactInformation - Contact information object
 * @returns {boolean} - True if phone numbers exist
 */
export const hasValidPhoneNumbers = (contactInformation) => {
	return contactInformation?.phoneNumbers?.length > 0;
};
